import { Box, Button, Typography } from "@mui/material";

// svg
import { ReactComponent as IconInformation } from "../../../assets/svg/information.svg";
import { TEXT } from "../../../constants/text";

export const LocationTab = ({ location }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        paddingLeft: "16px",
        width: "100%",
        pt: '6px'
      }}
    >
      <Typography sx={{ fontSize: "24px", mb: '24px' }}>{TEXT.siteSettings.locationTitle}</Typography>

     <Box
        sx={{
          background: "#EBEBEC",
          borderRadius: "8px",
          border: "1px solid #DBDBEB",
          padding: "8px",
          width: "100%",
        }}
      >
        <Typography
          sx={{ fontSize: "14px", color: location ? "#343745" : "#A2A3A9" }}
        >
          {location ? location.place_name : "Select location"}{" "}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", mt: "16px" }}>
        <Box>
          <IconInformation fill="#5D5F6A" width="24px" height="24px" />
        </Box>

        <Typography sx={{ fontSize: "12px", color: "#777982", ml: "8px" }}>
        {TEXT.siteSettings.locationTooltip}
        </Typography>
      </Box>

      {/* <Box sx={{ mt: "16px" }}>
        <Typography sx={{ fontSize: "12px", color: "#343745", ml: "8px" }}>
          No location is available?
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "#343745", ml: "8px" }}>
          Define a site without using the map.
        </Typography>
        <Button
          sx={{
            mt: "16px",
            color: "#343745",
            border: "1px solid #FBFBFD",
            background: "#fff",
            borderRadius: "8px",
            boxShadow: 3,
            textTransform: "capitalize",
            "&:hover": { boxShadow: 6 },
          }}
        >
          No Location
        </Button>
      </Box> */}
    </Box>
  );
};
